import React from "react";
import {
  Form,
  Fields,
} from "../../components/Form/Form";
import useStandService from "../../api/services/useStandService";
import standIcon from '../../assets/icons/stand-white.svg'
import Button from "../../components/Button/Button";
import TileList from "../../components/TileList/TileList";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";

const UserStands = () => {

  const {userShowCollection} = useStandService()

  return (
    <div className="page-user-stands">
      <div className="row">
        <div className="col">
          <h1>Stands</h1>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup
            location="/user/stands"
          />
        </div>
      </div>
      <p>Stands zijn: mobiele ondernemingen, foodtrucks, (markt) kraampje, ijs-bak-fietsen, acts, etc.</p>
      <Button
        label="Stand/Truck/Act aanmaken"
        linkState={{buttonPrev:{new:{onClick:{navigate:'/user/stands'}}}}}
        link="/wizard/stand/new"
        icon={standIcon}
      />
      <br/>
      <br/>
      <br/>
      <TileList
        apiServiceShow={userShowCollection}
        modelLabelKey="label"
        modelImageKey="overview_media"
        showBookableStatus={true}
        buttonProfileBaseUrl={'/stand/'}
        buttonOneDynamicUrl={'/user/stand/%id/manager'}
        buttonOneLabel={'Boekingen'}
        buttonTwoDynamicUrl={'/user/stand/%id/edit'}
        buttonTwoLabel={'Instellingen'}
      />
    </div>
  )
}


export default UserStands
